'use strict';

var lunr = require('lunr');

var _require = require('./common.js'),
    enhanceLunr = _require.enhanceLunr;

exports.onClientEntry = function (args, _ref) {
  var languages = _ref.languages;

  enhanceLunr(lunr, languages);
  fetch('/search_index.json').then(function (response) {
    return response.json();
  }).then(function (_ref2) {
    var index = _ref2.index,
        store = _ref2.store;

    window.__LUNR__ = { index: lunr.Index.load(index), store: store };
  }).catch(function (e) {
    return console.log('Failed fetch search index');
  });
};